module.exports = __webpack_public_path__ + "img/plane1.9f806af8.svg";